import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98d63872"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field--tax-residence" }
const _hoisted_2 = { class: "row custom-select-wrapper" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  key: 0,
  class: "personal-id-number-description"
}
const _hoisted_6 = {
  key: 1,
  class: "personal-id-number-description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheCountrySelect = _resolveComponent("TheCountrySelect")!
  const _component_PolandTaxResidenceField = _resolveComponent("PolandTaxResidenceField")!
  const _component_Field = _resolveComponent("Field")!
  const _component_NoTinField = _resolveComponent("NoTinField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheCountrySelect, {
        modelValue: _ctx.formData.taxCountry,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.formData.taxCountry = $event)),
        name: _ctx.name + 'TaxCountry',
        "country-list": _ctx.countries,
        label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.chooseTaxCountryResidence`),
        placeholder: 
                    _ctx.$t(`${_ctx.TRANSLATION_KEY}.chooseTaxCountryResidence`)
                ,
        "default-value": _ctx.formData.taxCountry || '',
        "input-id": _ctx.name + 'TaxCountry',
        class: "custom-select",
        "country-disable": _ctx.countryDisable,
        onSelectedCountry: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.taxCountry = $event))
      }, null, 8, ["modelValue", "name", "country-list", "label", "placeholder", "default-value", "input-id", "country-disable"])
    ]),
    (_ctx.isPolandTaxCountry)
      ? (_openBlock(), _createBlock(_component_PolandTaxResidenceField, {
          key: 0,
          name: _ctx.name,
          "tax-office-data-foreigner": _ctx.taxOfficeDataForeigner,
          "is-poland-tax-country": _ctx.isPolandTaxCountry,
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.receiveDataPL($event)))
        }, null, 8, ["name", "tax-office-data-foreigner", "is-poland-tax-country"]))
      : _createCommentVNode("", true),
    (!_ctx.isPolandTaxCountry)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (
                        _ctx.formData.taxCountry &&
                        _ctx.tinCountries.includes(_ctx.formData.taxCountry) &&
                        _ctx.formData.taxCountry.length > 0
                    )
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.Tin${_ctx.formData.taxCountry}`)), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.tinNumberPlaceholder`)), 1)),
            (!_ctx.formData.noTinNumber)
              ? (_openBlock(), _createBlock(_component_Field, {
                  key: 2,
                  type: "text",
                  name: _ctx.name + 'TinNumber',
                  disabled: _ctx.formData.emptyTinNumber ? true : false,
                  class: _normalizeClass(
                        _ctx.formData.emptyTinNumber ? 'empty-tin-number valid' : ''
                    ),
                  "model-value": _ctx.formData.tinNumber ?? '',
                  placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.number`),
                  "cy-data": "tin",
                  "is-numeric": _ctx.isNumericalTIN,
                  "force-uppercase": true,
                  "remove-whitespace": true,
                  "no-auto-validation": true,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.tinNumber = $event || null)),
                  onBlur: _ctx.emitValidateTin
                }, null, 8, ["name", "disabled", "class", "model-value", "placeholder", "is-numeric", "onBlur"]))
              : _createCommentVNode("", true)
          ]),
          (
                    _ctx.formData.taxCountry &&
                    _ctx.formData.taxCountry.length > 0 &&
                    !_ctx.tinCountries.includes(_ctx.formData.taxCountry)
                )
            ? (_openBlock(), _createBlock(_component_NoTinField, {
                key: 0,
                name: _ctx.name + 'NoTinNumber',
                onInput: _ctx.mergeFormData
              }, null, 8, ["name", "onInput"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}